import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";

const paperSx = {
  borderRadius: "var(--radius-md, 6px)",
  border: "1px solid var(--border-color)",
  boxShadow: "var(--shadow-sm)",
  bgcolor: "var(--surface-color)",
  overflow: "hidden",
};

/**
 * Reusable confirm dialog — use for logout, admin switch, delete, etc.
 */
const ConfirmDialog = ({
  open,
  title = "Confirm",
  message = "Are you sure you want to continue?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="confirm-dialog-title"
      PaperProps={{ sx: paperSx }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ fontWeight: 650, fontSize: 16, pb: 1, color: "var(--text-dark)" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, color: "var(--text-muted)" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onCancel}
          disabled={loading}
          color="inherit"
          variant="outlined"
          sx={{
            borderRadius: "var(--radius-md)",
            textTransform: "none",
            borderColor: "var(--border-color)",
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={loading}
          disableElevation
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }
          sx={{ borderRadius: "var(--radius-md)", textTransform: "none" }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
